// imove-behavior: 设置report组件参数


export default async function(ctx) {
  const { webReport, commonParams } = ctx.getPipe();
  const { setTest, setGetCommonParams, registerOnError } = webReport || {};

  if (process) {
    setTest(process?.env?.NODE_ENV === 'development' || process?.env?.TEST_ENV === 'true');
  } else {
    if (typeof location !== 'undefined') {
        const isProd = location.hostname === 'meeting.tencent.com' || location.hostname === 'voovmeeting.com';
        setTest(!isProd);
    } else {
        setTest(true);
    }
  }

  setGetCommonParams(() => ({
    ...commonParams,
  }));

  registerOnError((e, data) => {
    const ids = data?.map((m) => m.event_value.unique_report_id).join(',');
    ctx.emit('dataReportFail', {
      event: e,
      ids,
    })
  });

  return {
    webReport: webReport
  }
}
